import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const AuthCallbackPage = () => {
  const { search } = useLocation();
  const hasPosted = useRef(false);

  useEffect(() => {
    if (hasPosted.current) return; // only run once
    hasPosted.current = true;

    const params = new URLSearchParams(search);
    const code = params.get("code");
    const state = params.get("state");

    if (code && state && window.opener) {
      window.opener.postMessage(
        { type: "oktaCallback", code, state },
        window.location.origin
      );
    }

    window.close();
  }, [search]);

  return null;
};
